import {
  getAllNews,
  createNews,
  updateNews,
  deleteNews,
  getNewsById as fetchNewsById,
  bulkDeleteNews as bulkDeleteNewsService,
} from "../../helpers";
import {
  setLoading,
  setNews,
  addNews,
  updateNewsItem,
  deleteNewsItem,
  setError,
} from "./reducer";
import { createAsyncThunk } from "@reduxjs/toolkit";

// Fetch all news
export const fetchAllNews = (params = {}) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await getAllNews(params);
    dispatch(setNews(response || []));
  } catch (error) {
    dispatch(setError(error.message));
  } finally {
    dispatch(setLoading(false));
  }
};

// Create news
export const createNewsItem = (data) => async (dispatch) => {
  try {
    dispatch(setLoading(true));

    const response = await createNews(data);

    if (response?.status === 1) {
      dispatch(addNews(response.data));
      return {
        ok: true,
        data: response.data,
        message: response?.message || "News created successfully",
      };
    } else {
      return {
        ok: false,
        message: response?.message || "Failed to create news",
      };
    }
  } catch (error) {
    dispatch(setError(error.message));
    return { ok: false, message: error.message || "Failed to create news" };
  } finally {
    dispatch(setLoading(false));
  }
};

// Update news
export const updateNewsById = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoading(true));

    const response = await updateNews(id, data);

    if (response?.status === 1) {
      dispatch(updateNewsItem(response.data));
      return {
        ok: true,
        data: response.data,
        message: response?.message || "News updated successfully",
      };
    } else {
      return {
        ok: false,
        message: response?.message || "Failed to update news",
      };
    }
  } catch (error) {
    dispatch(setError(error.message));
    return { ok: false, message: error.message || "Failed to update news" };
  } finally {
    dispatch(setLoading(false));
  }
};

// Delete news
export const deleteNewsById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await deleteNews(id);
    
    if (response?.status === 1) {
      dispatch(deleteNewsItem(id));
      return {
        ok: true,
        message: response?.message || "News deleted successfully",
      };
    } else {
      return {
        ok: false,
        message: response?.message || "Failed to delete news",
      };
    }
  } catch (error) {
    dispatch(setError(error.message));
    return { ok: false, message: error.message || "Failed to delete news" };
  } finally {
    dispatch(setLoading(false));
  }
};

// Get news by ID
export const getNewsById = createAsyncThunk(
  "news/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetchNewsById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Bulk delete news
export const bulkDeleteNews = (newsIds) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const res = await bulkDeleteNewsService(newsIds);

    if (res?.status === 1) {
      dispatch(fetchAllNews());
      return {
        ok: true,
        message: res?.message || "News items deleted successfully",
      };
    } else {
      return {
        ok: false,
        message: res?.message || "Failed to delete news items",
      };
    }
  } catch (error) {
    return { ok: false, message: error.message || "Bulk delete failed" };
  } finally {
    dispatch(setLoading(false));
  }
};